
<div class="container" style="border:1px solid #bebaba">
  <br />

  <div class="row indentContent">
    <div class="col-md-12">
      The information on this website is only a summary of the terms of the Settlement. You may download a copy of the full Notice for each settlement at the links below. Since this website is just a summary, you should review the Notice and Settlement Agreements for additional details. The Settlement Agreements are available at the links below.<br/><br/>
      <ul>
        <li>
          For information regarding the settlements with Agri Stats, House of Raeford, Prestage, Foster Farms, Perdue, Hormel Foods Corporation, Jennie-o Turkey Store, Inc., and Butterball, LLC Defendants Settlements, please click <a [routerLink]="['/agri']">here</a>.
        </li>
        <li>
          Information regarding the settlements with Tyson or Cargill Defendants can be found on the Tyson or Cargill Settlements page of this website or by clicking <a [routerLink]="['/tyson']">here</a>.
        </li>
        <li>
          For information regarding the Certified Class or the settlements with Cooper Farms or Farbest Foods, please click <a [routerLink]="['/certified']">here</a>.
        </li>
      </ul>
    </div>
  </div>

  <br />
</div>
